<template>
    <div class="container">
        <div class="row faqs mx-auto mb-5">
            <div class="col-md-12">
                <h1 class="text-uppercase text-center mt-5 mb-5">
                    {{ $t('Support.SupportTitle') }}
                </h1>
                <div v-for="(faq, index) in faqs" :key="index">
                    <p class="mb-2"><strong>{{ faq.question }}</strong></p>
                    <p v-html="faq.answer" class="pb-3"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FAQ',
    data() {
        return {
            faqs: [],
            activeIndex: null,
            targetFaqKeyword: 'havingTrouble',
        };
    },
    created() {
        this.loadFaqs();
    },
    mounted() {
        // Open based on URL param
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('havingTrouble')) {
            this.openTargetFaq();
        }

        // Open first FAQ on any link click inside this component
        this.$nextTick(() => {
            const links = this.$el.querySelectorAll('a');
            links.forEach((link) => {
                link.addEventListener('click', () => {
                    this.activeIndex = 0;
                });
            });
        });
    },
    watch: {
        '$i18n.locale': 'loadFaqs',
    },
    methods: {
        async loadFaqs() {
            try {
                const currentLocale = this.$i18n.locale;
                const response = await fetch(`/locales/${currentLocale}.json`);
                const data = await response.json();

                if (data && data.Support) {
                    this.faqs = data.Support.faqs;
                } else {
                    console.error('Invalid FAQ data structure in', currentLocale);
                    this.faqs = [];
                }
            } catch (error) {
                console.error('Error loading FAQs:', error);
                this.faqs = [];
            }
        },
        toggle(index) {
            this.activeIndex = this.activeIndex === index ? null : index;
        },
        async openTargetFaq() {
            if (this.faqs.length === 0) {
                await this.loadFaqs();
            }

            const keyword = this.targetFaqKeyword.toLowerCase();
            const targetIndex = this.faqs.findIndex((faq) => {
                return (
                    (faq.id && faq.id.toLowerCase() === keyword) ||
                    (faq.question && faq.question.toLowerCase().includes(keyword))
                );
            });

            this.activeIndex = targetIndex !== -1 ? targetIndex : 0;

            // Wait for DOM to update, then scroll
            this.$nextTick(() => {
                const el = document.getElementById(`heading${this.activeIndex}`);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        },
    },
};
</script>
